export default {

  /*
  We wanted to use this directive on the sidebar.
  But the original directive intercepts the click on the sidebar toggler.
  So we added a condition on the toggler.
  */
 
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {

      // Check if it is a click on the toggler
      if (event.target.id=='sidenav-toggler' 
        || (event.target.parentElement && event.target.parentElement.id=="sidenav-toggler")) {
          return
      }

      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
};
